var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mt-2",attrs:{"rounded":"","outlined":"","color":"black"},on:{"click":_vm.composeNewMessage}},[_c('icon',{staticClass:"mr-2",attrs:{"icon":"pen","color":"#1D3557"}}),_c('span',{staticClass:"ml-1 lowercase"},[_vm._v("Compose")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }